import React from "react";
import "./CSS/History.css";
import groupImage from "./IMAGES/1001088671 2.png"; 
import logo2 from "./IMAGES/Bhairavnath logo2.png";

const Bhairavnath = () => {
  return (
    <section className="bhairavnath-container">
      <div className="image-box">
        <img  src={groupImage} alt="Bhairavnath Group" />
      </div>

      <div className="content-box">
        <div className="title">
         <img className="color-logo" src={logo2}/>
        </div>

        <h3 className="subtitle">मंडळाचा इतिहास</h3>
        <p className="description">
       भैरवनाथ हे आपल्या गावाचे ग्रामदैवत. त्यांच्या आशीर्वादाने व प्रेरणेने स्थापन झालेले भैरवनाथ मंडळ हे फक्त क्रीडा, सांस्कृतिक किंवा धार्मिक उपक्रमांपुरते मर्यादित न राहता समाजाच्या सर्वांगीण विकासासाठी कार्यरत आहे.

मंडळाच्या स्थापनेचा उद्देश केवळ मनोरंजन नव्हे, तर क्रीडा, संस्कृती, शिक्षण, आरोग्य व समाजसेवा या क्षेत्रात कार्य करून युवकांना योग्य दिशा देणे हा आहे.

आजच्या धकाधकीच्या जीवनात समाजाला एकत्र आणणे, सामाजिक भान जपणे, नव्या पिढीमध्ये देशप्रेम व समाजभान जागृत करणे ही काळाची गरज आहे. या जाणिवेतूनच आमचे मंडळ विविध सामाजिक उपक्रम, रक्तदान शिबिरे, वृक्षारोपण मोहीम, व्यसनमुक्ती अभियान, शैक्षणिक मार्गदर्शन, तसेच सांस्कृतिक कार्यक्रम राबवत असते.
<br />  आमचं ब्रीदवाक्य –  <br /> 
“क्रीडा, संस्कृती आणि समाजसेवा – हाच आमचा मार्ग!”  <br />

भैरवनाथ मंडळ आपल्या या छोट्याशा प्रयत्नातून समाजाला एक सकारात्मक दिशा देत आहे, आणि पुढेही समाजहितासाठी नवनवीन उपक्रम राबवण्याचा संकल्प आमचा आहे
</p>

       
      </div>
    </section>
  );
};

export default Bhairavnath;
